import axios from 'axios'

export interface MasterBill {
  name: string;
  amount: number;
  type: string;
  months: number[];
}

export interface StudentBill {
  [key: string]: Bill;
}

export interface Bill {
  [key: number]: number;
}

export interface TotalBill {
  [key: string]: number;
}

export interface BillDetailModel {
  name: string;
  status: number;
  month: number;
  deadline: number;
  total_amount: number;
  total_paid: number;
}

class StaticFactory {
  async masterBill () {
    try {
      const response = await axios.get('/data/master_bills.json')
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async months () {
    try {
      const response = await axios.get('/data/months.json')
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async students () {
    try {
      const response = await axios.get('/data/students.json')
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async billStatus () {
    try {
      const response = await axios.get('/data/bill_status.json')
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async billDetail () {
    try {
      const response = await axios.get('/data/bill_details.json')
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async studentPayments () {
    try {
      const response = await axios.get('/data/student_payments.json')
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async userPaymentHistory () {
    try {
      const response = await axios.get('/data/user_payments.json')
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async transactionMaps () {
    try {
      const response = await axios.get('/data/transactions')
      const data = response.data.data

      if (data.transaction_maps) {
        return data.transaction_maps
      }

      return {}
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const staticFactory = new StaticFactory()
